var render = function render(){var _vm=this,_c=_vm._self._c;return _c('virtual-assistant-lib',{attrs:{"send-chat-service":_vm.sendChatService,"get-citation-file-service":_vm.getCitationFileService,"download-service":_vm.downloadService,"user-full-name":_vm.userFullName}})
}
var staticRenderFns = []

export { render, staticRenderFns }